import React from 'react';

export interface CardContentProps {
  children: React.ReactNode;
  padding?: boolean;
  scroll?: boolean;
  maxHeight?: string;
  className?: string;
}

const CardContent: React.FC<CardContentProps> = ({
  children,
  padding = false,
  scroll = false,
  maxHeight,
  className = '',
}) => {
  const classes = [padding && 'p-6', scroll && 'overflow-auto', className]
    .filter(Boolean)
    .join(' ');

  const style = maxHeight ? { maxHeight } : undefined;

  return (
    <div className={classes} style={style}>
      {children}
    </div>
  );
};

export default CardContent;
